/**
 * FilterButton Component
 *
 * A "Filters" button for the IRP Workbook slim top bar that opens the PrimaryFilter
 * controls in a dropdown popover. Filtering is a rare, post-analysis step, so the
 * controls stay out of the way until needed. A dot indicator marks active filters.
 */

import React, {useState} from 'react';
import {Badge, Button, Popover} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PrimaryFilter from './PrimaryFilter';
import {usePrimaryFilter} from '../../../../../../stores/irp-workbook.store';

const FilterButton: React.FC = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const primaryFilter = usePrimaryFilter();

    const activeFilterCount =
        (primaryFilter.dateFrom || primaryFilter.dateTo ? 1 : 0) +
        (primaryFilter.selectedDescriptors.size > 0 ? 1 : 0) +
        (primaryFilter.selectedSources.size > 0 ? 1 : 0);

    const open = Boolean(anchorEl);

    return (
        <>
            <Badge color="primary" variant="dot" invisible={activeFilterCount === 0}>
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<FilterListIcon />}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(event): void => setAnchorEl(event.currentTarget)}
                    sx={{ whiteSpace: 'nowrap' }}
                >
                    Filters
                </Button>
            </Badge>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={(): void => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { sx: { p: 2, width: 440 } } }}
            >
                <PrimaryFilter />
            </Popover>
        </>
    );
};

export default FilterButton;
